export const MaskedOrUnmaskedAliasResponseType = "MaskedOrUnmaskedAlias";
